module.exports = __webpack_public_path__ + "media/images/front/programs/icon-arrow-right-active-fb3c9690ba606f22042217aee2042397.svg";